import { Caption, VideoList } from "../../subcomponents/subcomponents";
import Styles from "./video_player.module.css";
import testImg from "../../images/11905945_4857949.jpg";
import testVid from "../../images/video.mp4";
import { VideoSection } from "./video_player_components";
export const VideoPlayerBody = ( props ) => {
    const { } = props;
    const { Content } = Styles;
    const data = {
        id: 424,
        videoLink  : testVid,
        playerTheme : "#009688",
        Attributes : [
            { icon: <i className="bi bi-play-circle-fill"></i>, span: <span></span>, text: "#4" },
            { icon: <i className="bi bi-clock-fill"></i>, span: <span></span>, text: "17mins" },
            { icon: <i></i>, span: <span style={{ display: "none" }}></span>, text: "FREE", color: "green" },
            { icon: <i className="bi bi-share-fill" style={{ cursor: "pointer" }}></i>, span: <span style={{ display: "none" }}></span> },
            { icon: <i className="bi bi-cloud-arrow-down-fill" style={{ fontSize: "25px", cursor: "pointer", color: "green" }}></i>, span: <span style={{ display: "none" }}></span> },
        ],
        videoName  : "Test Video",
        videoNameIcon : <i className="bi bi-feather"></i>,
        videoNameTheme : "#607d8b",
        videoRate : <><i className="bi bi-star-fill" style={{ margin: "0 5px" }}></i><i className="bi bi-star-fill" style={{ margin: "0 5px" }}></i><i className="bi bi-star-fill" style={{ margin: "0 5px" }}></i><i className="bi bi-star-half" style={{ margin: "0 5px" }}></i><i className="bi bi-star" style={{ margin: "0 5px" }}></i></>,
        videoRateIcon : <i className="bi bi-bookmark-star"></i>,
        videoRateTheme: "#ffc107",
        warnings: [
            { 
                title: "Copy Rights", 
                text: " This video is protected by copyright. Unauthorized reproduction or distribution may result in legal action.", 
            },
        ],
        warningsTheme: "#f44336",
        warningsColor: "white",
        sections: [
            {
                title: "Introduction to AI",
                text: "This video explores the basics of Artificial Intelligence, including machine learning, neural networks, and real-world applications."
            },
            {
                title: "History of Space Exploration",
                text: "A deep dive into the milestones of space exploration, from the first satellite to the latest Mars missions."
            },
            {
                title: "Beginner’s Guide to Python",
                text: "Learn the fundamentals of Python programming, including syntax, data types, and basic problem-solving techniques."
            },
            {
                title: "The Future of Renewable Energy",
                text: "This video discusses the advancements in renewable energy sources like solar, wind, and hydroelectric power."
            },
            {
                title: "Top 10 Productivity Hacks",
                text: "Discover simple and effective ways to boost your productivity, manage time, and stay focused on your goals."
            }
        ],
        captionTheme: "gray",
        captionColor: "lightgray",
        date: "2024/10/23",
        videoListTitle: { icon: <i className="bi bi-play-circle-fill"></i>, text: "Videos" },
        videoList: [
            { id: 234,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
            { id: 234,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
            { id: 234,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
            { id: 234,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
            { id: 424,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
            { id: 234,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
            { id: 234,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
            { id: 234,image: testImg, text: "A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic.", duration: "17mins", link: null, theme: "#607d8b", substring: 77 },
        ],
    };
    return (
        <main className={ Content }>
            <VideoSection videoData = { data }/>
            <VideoList width={ 350 } title={ data.videoListTitle } videos={ data.videoList } currentVideo={ data.id }/>
        </main>
    );
};